const getObjectDeepKeys = (obj: any): any =>
  Object.keys(obj)
    .filter(key => obj[key] instanceof Object)
    .map(key => getObjectDeepKeys(obj[key]).map((k: string) => `${key}.${k}`))
    .reduce((x, y) => x.concat(y), Object.keys(obj));

export default getObjectDeepKeys;
